import { render, staticRenderFns } from "./filesUpload.vue?vue&type=template&id=40f5db6a"
import script from "./filesUpload.vue?vue&type=script&lang=js"
export * from "./filesUpload.vue?vue&type=script&lang=js"
import style0 from "./filesUpload.vue?vue&type=style&index=0&id=40f5db6a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports